export default "__VITE_ASSET__r1utWtzC__"